<!--
  Copyright (C) 2022 - Jeci SARL - https://jeci.fr

  This program is free software: you can redistribute it and/or modify
  it under the terms of the GNU Affero General Public License as
  published by the Free Software Foundation, either version 3 of the
  License, or (at your option) any later version.

  This program is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU Affero General Public License for more details.

  You should have received a copy of the GNU Affero General Public License
  along with this program.  If not, see https://www.gnu.org/licenses/agpl-3.0.html.
-->

<!-- eslint-disable vue/no-root-v-if -->
<template>
  <PrimeMessage
    v-if="helpKey"
    :closable="false"
    severity="secondary"
    class="text-lg font-semibold p-0"
    size="large"
    @click="changeHelpKey"
  >
    <p class="ml-1 font-bold">Liste des Raccourcies Claviers</p>
    <div class="keydef">
      <span><i class="ri-arrow-left-line" aria-hidden="true"></i></span>Page
      Précédente
    </div>
    <div class="keydef">
      <span><i class="ri-arrow-right-line" aria-hidden="true"></i></span>Page
      Suivante
    </div>
    <div class="keydef">
      <span>CTRL+<i class="ri-arrow-up-line" aria-hidden="true" /></span
      >Document Précédente
    </div>
    <div class="keydef">
      <span>CTRL+<i class="ri-arrow-down-line" aria-hidden="true" /></span
      >Document Suivante
    </div>
    <div class="keydef"><span>+</span>Zoomer</div>
    <div class="keydef"><span>-</span>Dézoomer</div>
    <div class="keydef"><span>0</span>Zoom adapté à la hauteur</div>
    <div class="keydef"><span>5</span>Zoom adapté à la largeur</div>
    <div class="keydef"><span>ECHAP</span>Fermer la prévisualisation</div>
    <div class="keydef"><span>ENTER</span>Ouvre le document</div>
  </PrimeMessage>
</template>
<script>
import Message from "primevue/message";

export default {
  name: "HelpKeyMessage",
  components: {
    PrimeMessage: Message,
  },
  props: {
    helpKey: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["set-help-hey"],
  methods: {
    changeHelpKey() {
      this.$emit("set-help-hey", false);
    },
  },
};
</script>
<style lang="css" scoped>
.keydef {
  margin-right: 0;
  margin-left: 0.25rem;
}

.keydef span {
  display: inline-block;
  font-family: monospace;
  width: 4.5rem;
}
.p-message {
  padding: 1.25rem 0 !important;
}
</style>
